/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { connect } from 'inferno-redux';
// actual presentational component that will utilize application state and actions (will be exported after being infused with state/actions)
import Body from 'components/shared/body/body';



/* ========== ~~~~~~~~~~ BODY : PARENT ~~~~~~~~~~ ========== */
// CONTAINER COMPONENT
// interacts with redux (store of application state)
// infuses child component (imported above) with state & actions by mapping and then connecting them

// map state
const mapStateToProps = ({ contentStatus, settings, rewards }, { contentId }) => ({
    currentContentStatus: contentStatus[contentId],
    currentContentSettings: settings.contentSettings[contentId],
    rewardsEnabled: rewards.settings.enabled,
    rewardsPermitted: rewards.status.rewardsPermitted
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// utilizes "connect" functionality from redux in order to infuse state/actions as props to child component
// will be utilized from any component that wants to incorporate "Content" component
export default connect(
  mapStateToProps
)(Body);
